import { useEffect, useMemo } from 'react';

interface JsonLdProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>;
}

/**
 * Inietta un blocco <script type="application/ld+json"> nel <head>
 * e lo rimuove quando il componente viene smontato (navigazione SPA).
 */
export function JsonLd({ data }: JsonLdProps) {
  const json = useMemo(() => JSON.stringify(data), [data]);

  useEffect(() => {
    // Rimuove lo schema statico iniettato a build time (SSG) per evitare
    // blocchi JSON-LD duplicati quando la pagina ne gestisce uno a runtime.
    document.querySelectorAll('script[data-ssg]').forEach((s) => s.remove());
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = json;
    document.head.appendChild(script);
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [json]);

  return null;
}
